import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import { useAppContext } from '../../AppContext';
import './StoryApp.css'; 


const settings = [
  { name: "Medieval Kingdom", image: `${process.env.PUBLIC_URL}/images/medieval_kingdom3.png`, fgImage: `${process.env.PUBLIC_URL}/images/bg_green2.png` },
  { name: "Wild West", image: `${process.env.PUBLIC_URL}/images/wild_west3.png`, fgImage: `${process.env.PUBLIC_URL}/images/bg_sand.png` },
  { name: "Pirate Ships", image: `${process.env.PUBLIC_URL}/images/pirate_ships3.png`, fgImage: `${process.env.PUBLIC_URL}/images/bg_green2.png` },
];

const villains = [
  { name: "Sir Slumber", image: `${process.env.PUBLIC_URL}/images/slumber_fs2.png`, description: "Puts everyone to sleep" },
  { name: "Lilith Liar", image: `${process.env.PUBLIC_URL}/images/lilith_fs2.png`, description: "Deceives with lies" },
  { name: "Captain Quicksand", image: `${process.env.PUBLIC_URL}/images/captain_fs2.png`, description: "Sinks cities in quicksand" },
];

type Villain = {
  name: string;
  image: string;
  description: string;
};

function VillainSelection() {
  const { setting, isFullScreen, selectVillain, toggleFullScreen } = useAppContext();
  

  const [selectedVillainIndex, setSelectedVillainIndex] = useState(0);
  const [shuffledVillains, setShuffledVillains] = useState<Villain[]>([]);

  useEffect(() => {
    const villainsToShuffle = [...villains]; // Copy characters
    shuffleArray(villainsToShuffle); // Shuffle characters
    setShuffledVillains(villainsToShuffle); // Set shuffled characters to state
  }, []);

  const shuffleArray = (array: Villain[]) => {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
  }

  const settingImage = settings.find((c) => c.name === setting)?.image;
  const fgSettingImage = settings.find((c) => c.name === setting)?.fgImage;

  const navigate = useNavigate();

  const handleSwipe = (direction: string) => {
    if(direction === 'right') {
      setSelectedVillainIndex((prevIndex) =>
        prevIndex === shuffledVillains.length - 1 ? 0 : prevIndex + 1
      );
    } else if (direction === 'left') {
      setSelectedVillainIndex((prevIndex) =>
        prevIndex === 0 ? shuffledVillains.length - 1 : prevIndex - 1
      );
    }
  };

  const handleGoBack = () => {
    navigate("/setting");
  }

  const navigateToNext = () => {
    selectVillain(shuffledVillains[selectedVillainIndex].name);
    navigate("/helper");
  }

  // Render conditionally to ensure shuffledSettings is loaded
  if (shuffledVillains.length === 0) {
    return <div>Loading...</div>; // Or any other placeholder content
  }

  return (
    <div className="dimension-container">
      <div className="selection-container px-0"
        style={{
          backgroundImage: `url(${settingImage})`,
          backgroundSize: 'cover', 
          backgroundRepeat: 'no-repeat', 
        }}>
        <div className="nav-buttons">
          <i className="bi bi-arrow-left-circle back-button" onClick={handleGoBack}></i>
          <i className={`bi ${isFullScreen ? 'bi-fullscreen-exit' : 'bi-fullscreen'} fullscreen-button`} onClick={toggleFullScreen}></i>
        </div>
        <h1 className="text-80 text-center title-font-bold">Choose the villain</h1>
        <div className="selection-navigation">
          <div className="left-button" onClick={() => handleSwipe('left')}>
            <i className="bi bi-caret-left-fill"></i>
          </div>
          <div className="right-button" onClick={() => handleSwipe('right')}>
            <i className="bi bi-caret-right-fill"></i>
          </div>
        </div>
        <div className="character-display background">
          <img src={process.env.PUBLIC_URL + fgSettingImage} alt={"background"} />
        </div>
        <div className="character-display">
          <img src={process.env.PUBLIC_URL + shuffledVillains[selectedVillainIndex].image} alt={shuffledVillains[selectedVillainIndex].name} />
        </div>
        <h1 className="text-large2 title-font-bold">{shuffledVillains[selectedVillainIndex].name}</h1>
        <h3 className="text-large3 title-font-bold">{shuffledVillains[selectedVillainIndex].description}</h3>
        <button className="next-button" onClick={navigateToNext}>Next</button>
        <div className="pagination">
          {shuffledVillains.map((_, index) => (
            <div key={index} className={`dot ${index === selectedVillainIndex ? 'active' : ''}`} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default VillainSelection;
